// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"nca-z","narrowOptionButtons":"oca-z","noOptions":"pca-z"};